import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ClosingCta() {
  return <section id="closing-cta" className="relative py-20 md:py-32 bg-gradient-to-br from-[#0F1B2D] to-[#1A2A40] text-white overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.03)_0%,transparent_100%)] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white tracking-tight">
            Set Up a Recurring Marking Program
          </h2>
          
          <p className="font-default text-lg md:text-xl text-white/80 mb-10 leading-relaxed">
            Send Evermark Industrial Solutions your nameplate spec and volumes, approve a first article, and reorder to the same standard every build — consistent nameplates, data plates, and direct part marking, on your production schedule.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto text-base font-semibold">
              <Link to="/ContactPage">Set Up an OEM Program</Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base font-semibold bg-transparent border-white/30 text-white hover:bg-white/10 hover:text-white">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}